import script from "./VitaRightBarHead.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaRightBarHead.vue?vue&type=script&lang=ts&setup=true"

import "./VitaRightBarHead.vue?vue&type=style&index=0&id=deda93c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deda93c0"]])

export default __exports__